import moment from 'moment';

export default class EneTracker {
  constructor({
    id,
    articleCode,
    storeid,
    storeName,
    articleDescription,
    complainNumberSharedByBrand,
    customerMobileNumber,
    cnQuantity,
    replacementTagNumber,
    complainDateWithBrand,
    issueWithProduct,
    issueResolved,
    invoiceNumber,
    invoiceDate,
    complaintAge,
    index,
    imagesUrl,
    createdAt
  }) {
    this.id = id || '';
    this.articleCode = articleCode || '';
    this.index = index || 1;
    this.storeName = storeName || '';
    this.articleDescription = articleDescription || '';
    this.complainNumberSharedByBrand = complainNumberSharedByBrand || '';
    this.customerMobileNumber = customerMobileNumber || '';
    this.cnQuantity = cnQuantity || '';
    this.replacementTagNumber = replacementTagNumber || '';
    this.complainDateWithBrand = moment(complainDateWithBrand).format('YYYY-MM-DD');
    this.invoiceDate = moment(invoiceDate).format('YYYY-MM-DD');
    this.invoiceNumber = invoiceNumber || '';
    this.storeid = storeid || '';
    this.issueWithProduct = issueWithProduct || issueWithProduct;
    this.issueResolved = issueResolved || 'PENDING';
    this.createdAt = createdAt || null;
    this.complaintAge = complaintAge || '';
    this.imagesUrl = imagesUrl || [];
  }
}
